import { render, staticRenderFns } from "./ResultsViewTask.vue?vue&type=template&id=49245bc4&"
import script from "./ResultsViewTask.vue?vue&type=script&lang=ts&"
export * from "./ResultsViewTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports